import React from 'react';
import { Link } from 'react-router-dom';

const RelatedProducts = ({ relatedProducts }) => {
  if (!relatedProducts || relatedProducts.length === 0) return null;

  return (
    <section className="py-12 md:py-20 bg-gradient-to-b from-[#f9fafb] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6 md:mb-8">Related Products</h2>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
          {relatedProducts.map((relatedProduct) => (
            <Link
              key={relatedProduct.id}
              to={`/products/${relatedProduct.slug}`}
              className="group relative"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 rounded-2xl blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
              <div className="relative bg-white border border-gray-200 rounded-2xl overflow-hidden hover:border-cyan-300 transition-all duration-500 transform hover:-translate-y-2 hover:shadow-2xl">
                <div className="aspect-video overflow-hidden bg-gradient-to-br from-gray-100 to-gray-50">
                  <img
                    src={relatedProduct.image}
                    alt={relatedProduct.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-cyan-600 transition-colors">
                    {relatedProduct.name}
                  </h3>
                  <p className="text-gray-600 text-sm line-clamp-2">
                    {relatedProduct.shortDescription}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedProducts;
